export const PRODUZIONI = [
  {
    id: "il-segreto-di-liberato",
    titolo: "Il Segreto di Liberato",
    categoria: "Lungometraggio · Music Film",
    anno: null,
    cliente: null,
    img: "/posters/il-segreto-di-liberato.jpg",
    cover: "/gallery/liberato-2.jpg",
    gallery: ["/gallery/liberato-1.jpg", "/gallery/liberato-2.jpg", "/gallery/liberato-3.jpg", "/gallery/liberato-4.jpg"],
    breve: "La prima opera cinematografica sulla figura enigmatica di Liberato.",
    descrizione:
      "Questo film rappresenta una prima assoluta nel panorama cinematografico, portando sul grande schermo la figura enigmatica di Liberato, il musicista napoletano la cui identità rimane un talento avvolto nel mistero. Emergendo nel 2017, Liberato ha rapidamente catturato l'attenzione del pubblico e della critica con i suoi tre album pubblicati fino al 2022. Oltre alla sua musica, che mescola sapientemente elementi di pop, elettronica e tradizione napoletana, Liberato è noto per i suoi videoclip innovativi che hanno accumulato milioni di visualizzazioni, consolidandosi come uno dei pilastri della musica indipendente italiana.",
    ruolo: "Produzione Red Private: sviluppo e realizzazione della prima opera cinematografica dedicata all'universo di Liberato. Un film di Francesco Lettieri.",
    dettagli: [
      { label: "Regia", value: "Francesco Lettieri" },
      { label: "Soggetto", value: "Liberato" },
      { label: "Genere", value: "Music film" },
    ],
    riconoscimento: "Prima assoluta: Liberato arriva per la prima volta sul grande schermo",
    en: {
      categoria: "Feature Film · Music Film",
      breve: "The first cinematic work about the enigmatic figure of Liberato.",
      descrizione:
        "A world first for cinema, bringing to the big screen the enigmatic figure of Liberato, the Neapolitan musician whose identity remains a talent wrapped in mystery. Emerging in 2017, Liberato quickly captured audiences and critics with three albums released through 2022. Beyond his music — a masterful blend of pop, electronica and Neapolitan tradition — he is known for groundbreaking music videos with millions of views, establishing him as a pillar of Italian independent music.",
      ruolo: "Produced by Red Private: development and delivery of the first cinematic work dedicated to Liberato's universe. A film by Francesco Lettieri.",
      dettagli: [
        { label: "Director", value: "Francesco Lettieri" },
        { label: "Subject", value: "Liberato" },
        { label: "Genre", value: "Music film" },
      ],
      riconoscimento: "A world first: Liberato comes to the big screen",
    },
  },
  {
    id: "the-basketball-dream",
    titolo: "The Basketball Dream: Marco Belinelli",
    categoria: "Docufilm · Sport",
    anno: null,
    cliente: "Rai Documentari",
    img: "/posters/the-basketball-dream.jpg",
    cover: "/gallery/belinelli-1.jpg",
    gallery: ["/gallery/belinelli-1.jpg", "/gallery/belinelli-2.jpg"],
    breve: "Il primo italiano della storia a conquistare un anello NBA.",
    descrizione:
      "Il docufilm racconta l'incredibile parabola di un ragazzo di San Giovanni in Persiceto che ha inseguito il sogno americano fino a diventare il primo italiano della storia a conquistare un anello NBA. Un viaggio intenso fatto di sacrifici, solitudine e determinazione negli Stati Uniti, culminato con il trionfo ai San Antonio Spurs. Il suo ritorno a Bologna segna oggi il desiderio di trasmettere valori, esperienza e passione alle nuove generazioni, a dimostrazione che con il coraggio nessun traguardo è impossibile.",
    ruolo: "Prodotto con orgoglio dal team Red Private, in due versioni: un'uscita cinema da 75' e una serie in due episodi da 50' per Rai Documentari.",
    dettagli: [
      { label: "Sceneggiatura", value: "Francesco Zippel" },
      { label: "Regia", value: "Francesco Lettieri e Giorgio Testi" },
      { label: "Formati", value: "75' cinema · 2×50' Rai Documentari" },
    ],
    riconoscimento: "Uscita premium in sala — 16/17/18 marzo 2026",
    en: {
      categoria: "Documentary · Sport",
      breve: "The first Italian in history to win an NBA ring.",
      descrizione:
        "The docufilm tells the incredible journey of a boy from San Giovanni in Persiceto who chased the American dream all the way to becoming the first Italian in history to win an NBA ring. An intense story of sacrifice, loneliness and determination in the United States, crowned by triumph with the San Antonio Spurs. His return to Bologna reflects his drive to pass on values, experience and passion to new generations — proof that with courage, no goal is impossible.",
      ruolo: "Proudly produced by the Red Private team, in two versions: a 75' theatrical cut and a two-episode 50' series for Rai Documentari.",
      dettagli: [
        { label: "Screenplay", value: "Francesco Zippel" },
        { label: "Directors", value: "Francesco Lettieri and Giorgio Testi" },
        { label: "Formats", value: "75' theatrical · 2×50' Rai Documentari" },
      ],
      riconoscimento: "Premium theatrical release — March 16/17/18, 2026",
    },
  },
  {
    id: "avemaria",
    titolo: "AVEMMARIA",
    categoria: "Lungometraggio · Cinema d'autore",
    anno: null,
    cliente: "Rai Cinema · Europictures",
    img: "/posters/avemaria.jpg",
    cover: "/gallery/avemaria-cover.jpg",
    gallery: ["/gallery/avemaria-1.jpg", "/gallery/avemaria-2.jpg", "/gallery/avemaria-3.jpg"],
    breve: "L'esordio alla regia di Fortunato Cerlino, nella Napoli degli anni Ottanta.",
    descrizione:
      "La pellicola racconta la storia di Felice, un ragazzo cresciuto nel quartiere di Pianura, in un contesto segnato da povertà, violenza e profonde difficoltà sociali. Nonostante la durezza della realtà circostante, il giovane protagonista affronta la vita con coraggio e immaginazione, trovando nei sogni la forza per riscattare il proprio destino. Un intenso racconto di formazione che celebra la resilienza, la crescita e la capacità di sognare anche nei contesti più complessi.",
    ruolo: "Prodotto in co-produzione con partner di rilievo del panorama nazionale, realizzato con il contributo di Rai Cinema e distribuito da Europictures: il tassello che ha aperto Red Private al cinema d'autore.",
    dettagli: [
      { label: "Regia", value: "Fortunato Cerlino (esordio)" },
      { label: "Cast", value: "Mario Di Leva · Salvatore Esposito · Marianna Fontana" },
      { label: "Distribuzione", value: "Europictures" },
    ],
    riconoscimento: "Official Selection — 43° Torino Film Festival · Con il contributo di Rai Cinema",
    en: {
      categoria: "Feature Film · Arthouse Cinema",
      breve: "Fortunato Cerlino's directorial debut, set in 1980s Naples.",
      descrizione:
        "The film tells the story of Felice, a boy raised in the Pianura district amid poverty, violence and deep social hardship. Despite the harshness of the reality around him, the young protagonist faces life with courage and imagination, finding in dreams the strength to redeem his destiny. An intense coming-of-age story celebrating resilience, growth and the ability to dream even in the most complex contexts.",
      ruolo: "Co-produced with leading national partners, made with the support of Rai Cinema and distributed by Europictures: the milestone that opened Red Private to arthouse cinema.",
      dettagli: [
        { label: "Director", value: "Fortunato Cerlino (debut)" },
        { label: "Cast", value: "Mario Di Leva · Salvatore Esposito · Marianna Fontana" },
        { label: "Distribution", value: "Europictures" },
      ],
      riconoscimento: "Official Selection — 43rd Torino Film Festival · Supported by Rai Cinema",
    },
  },
  {
    id: "maserati-the-brothers",
    titolo: "Maserati: The Brothers",
    categoria: "Produzione esecutiva · Film internazionale",
    anno: null,
    cliente: null,
    img: "/posters/maserati-the-brothers.jpg",
    cover: "/gallery/maserati-1.jpg",
    gallery: ["/gallery/maserati-1.jpg", "/gallery/maserati-2.jpg", "/gallery/maserati-3.jpg"],
    breve: "Produzione esecutiva italiana per il film internazionale di Bobby Moresco.",
    descrizione:
      "Red Private ha curato e coordinato la produzione esecutiva in Italia di Maserati: The Brothers, il prestigioso lungometraggio internazionale diretto dal Premio Oscar® Bobby Moresco. La società ha gestito con successo una complessa macchina produttiva ad alto budget tra gli Studios De Paolis e alcune delle location italiane più iconiche, coordinando oltre 600 professionisti e un cast stellare che include Al Pacino, Anthony Hopkins, Andy Garcia, Michele Morrone, Jessica Alba e Salvatore Esposito, arricchito dalle musiche straordinarie di Andrea Bocelli e Jennifer Hudson, scritte dalla pluri-candidata all'Oscar Diane Warren.",
    ruolo: "Produzione esecutiva in Italia: cura e coordinamento dell'intera macchina produttiva tra Studios De Paolis e le location italiane. Dopo Skincare, un progetto che consolida Red Private nel panorama internazionale.",
    dettagli: [
      { label: "Regia", value: "Bobby Moresco (Premio Oscar®)" },
      { label: "Cast", value: "Al Pacino · Anthony Hopkins · Andy Garcia · Michele Morrone · Jessica Alba · Salvatore Esposito" },
      { label: "Musiche", value: "Andrea Bocelli · Jennifer Hudson · Diane Warren" },
      { label: "Professionisti", value: "600+ coordinati sul set" },
    ],
    riconoscimento: "Produzione esecutiva internazionale — dopo il film Skincare",
    en: {
      categoria: "Executive Production · International Film",
      breve: "Italian executive production for Bobby Moresco's international feature film.",
      descrizione:
        "Red Private managed and coordinated the Italian executive production of Maserati: The Brothers, the prestigious international feature directed by Academy Award® winner Bobby Moresco. The company successfully ran a complex, high-budget production machine between the De Paolis Studios and some of Italy's most iconic locations, coordinating over 600 professionals and a stellar cast including Al Pacino, Anthony Hopkins, Andy Garcia, Michele Morrone, Jessica Alba and Salvatore Esposito, enriched by the extraordinary music of Andrea Bocelli and Jennifer Hudson, written by multi-Oscar nominee Diane Warren.",
      ruolo: "Executive production in Italy: full management and coordination of the production machine across De Paolis Studios and Italian locations. After Skincare, a project that consolidates Red Private on the international scene.",
      dettagli: [
        { label: "Director", value: "Bobby Moresco (Academy Award®)" },
        { label: "Cast", value: "Al Pacino · Anthony Hopkins · Andy Garcia · Michele Morrone · Jessica Alba · Salvatore Esposito" },
        { label: "Music", value: "Andrea Bocelli · Jennifer Hudson · Diane Warren" },
        { label: "Professionals", value: "600+ coordinated on set" },
      ],
      riconoscimento: "International executive production — following the film Skincare",
    },
  },
  {
    id: "skincare",
    titolo: "Skincare",
    categoria: "Produzione esecutiva · Thriller Dark Comedy",
    anno: null,
    cliente: null,
    img: "/posters/skincare.jpg",
    cover: "/gallery/skincare-1.jpg",
    gallery: ["/gallery/skincare-1.jpg", "/gallery/skincare-2.jpg", "/gallery/skincare-3.jpg"],
    breve: "Thriller dai toni dark comedy nella Los Angeles patinata del beauty business.",
    descrizione:
      "Ambientato nella Los Angeles patinata del beauty business, il film racconta la parabola di un'affermata estetista che, alla vigilia del lancio della propria linea di prodotti, si ritrova coinvolta in una spirale di sabotaggi e minacce orchestrate da un rivale. Un thriller dai toni dark comedy, ispirato a una storia vera.",
    ruolo: "Red Private ha curato la produzione esecutiva italiana del film: il progetto che ha aperto la strada alla collaborazione internazionale poi consolidata con Maserati: The Brothers.",
    dettagli: [
      { label: "Regia", value: "Austin Peters" },
      { label: "Cast", value: "Elizabeth Banks · Lewis Pullman · Nathan Fillion" },
      { label: "Genere", value: "Thriller · Dark comedy" },
      { label: "Note", value: "Ispirato a una storia vera" },
    ],
    riconoscimento: "Produzione esecutiva italiana — Red Private",
    en: {
      categoria: "Executive Production · Dark Comedy Thriller",
      breve: "A dark comedy thriller set in the glossy Los Angeles beauty business.",
      descrizione:
        "Set in the glossy Los Angeles beauty business, the film follows a renowned aesthetician who, on the eve of launching her own product line, becomes entangled in a spiral of sabotage and threats orchestrated by a rival. A thriller with dark comedy tones, inspired by a true story.",
      ruolo: "Red Private handled the film's Italian executive production: the project that paved the way for the international collaboration later consolidated with Maserati: The Brothers.",
      dettagli: [
        { label: "Director", value: "Austin Peters" },
        { label: "Cast", value: "Elizabeth Banks · Lewis Pullman · Nathan Fillion" },
        { label: "Genre", value: "Thriller · Dark comedy" },
        { label: "Notes", value: "Inspired by a true story" },
      ],
      riconoscimento: "Italian executive production — Red Private",
    },
  },
];

export const TEAM = [
  {
    nome: "Armando Chiosi",
    ruolo: "Founder · CFO",
    img: "/team/armando.jpg",
    bio: "Laurea magistrale in Giurisprudenza presso l'Università di Tor Vergata, con specializzazione in European and International Tax Law. Supervisione strategica, finanziaria e operativa di ogni produzione.",
    skills: ["Strategia", "Finanza", "Tax law internazionale"],
    en: {
      bio: "Master's degree in Law from the University of Tor Vergata, specializing in European and International Tax Law. Strategic, financial and operational supervision of every production.",
      skills: ["Strategy", "Finance", "International tax law"],
    },
  },
  {
    nome: "Ottavio Petroni",
    ruolo: "CEO",
    img: "/team/ottavio.jpg",
    bio: "Amministra la società e guida lo sviluppo commerciale, con particolare focus su sponsor e vendite: gestisce partner commerciali e brand integration, dalla promozione alla negoziazione fino al placement sulle piattaforme.",
    skills: ["Sponsor & brand", "Vendita OTT", "Negoziazione"],
    en: {
      bio: "Manages the company and leads commercial development, with a special focus on sponsorship and sales: commercial partners and brand integration, from promotion and negotiation to platform placement.",
      skills: ["Sponsors & brands", "OTT sales", "Negotiation"],
    },
  },
  {
    nome: "Valerio Rotoloni",
    ruolo: "Direttore di Produzione",
    img: "/team/valerio.jpg",
    bio: "È il punto di unione tra la visione artistica del progetto e la realtà del set. Gestisce la macchina logistica dell'audiovisivo orchestrando troupe, location, forniture e reparti tecnici. Risolve le criticità e mantiene il perfetto equilibrio tra creatività, ottimizzazione del budget e rispetto dei tempi di produzione.",
    skills: ["Pianificazione", "Organizzazione set", "Risorse in loco"],
    en: {
      ruolo: "Production Director",
      bio: "He is the link between the project's artistic vision and the reality of the set. He manages the audiovisual logistics machine, orchestrating crew, locations, supplies and technical departments. He resolves critical issues and maintains the perfect balance between creativity, budget optimization and respect for production timelines.",
      skills: ["Planning", "Set organization", "On-location resources"],
    },
  },
  {
    nome: "Giulia Nardini",
    ruolo: "Coordinatore di Produzione",
    img: "/team/giulia.jpg",
    bio: "Gestisce il flusso operativo quotidiano del set o della produzione, fungendo da punto di riferimento tra la logistica, la gestione dei contratti, i flussi tecnici e il coordinamento operativo della troupe giornaliera (daily crew), garantendo efficienza e puntualità in ogni fase.",
    skills: ["Logistica", "Contratti", "Daily crew"],
    en: {
      ruolo: "Production Coordinator",
      bio: "Manages the daily operational flow of the set or production, acting as the point of reference between logistics, contract management, technical workflows and the operational coordination of the daily crew, ensuring efficiency and punctuality at every stage.",
      skills: ["Logistics", "Contracts", "Daily crew"],
    },
  },
];

export const STATS = [
  { value: 10, suffix: "+", label: "Produzioni realizzate", label_en: "Productions completed" },
  { value: 600, suffix: "+", label: "Professionisti coordinati", label_en: "Professionals coordinated" },
  { value: 3, suffix: "", label: "Premi Oscar® coinvolti", label_en: "Oscar® winners involved" },
  { value: 2, suffix: "", label: "Sedi italiane", label_en: "Italian offices" },
];

export const MARQUEE_ITEMS = [
  "Cinema d'autore",
  "Docufilm",
  "Produzione esecutiva internazionale",
  "Co-produzioni",
  "Red Private SRL",
];

export const MARQUEE_ITEMS_EN = [
  "Arthouse cinema",
  "Documentary films",
  "International executive production",
  "Co-productions",
  "Red Private SRL",
];

export const CONTATTI = {
  sedi: "Viale Pasteur 31, 00144 Roma",
  email: "info@redpvt.com",
};

export const TIPI_RICHIESTA = [
  "Lungometraggio / Film",
  "Docufilm / Documentario",
  "Produzione esecutiva",
  "Co-produzione",
  "Altro",
];

export const TIPI_RICHIESTA_EN = [
  "Feature film",
  "Documentary",
  "Executive production",
  "Co-production",
  "Other",
];

// Comunicati pronti ma non pubblicati (in attesa di lancio ufficiale)
export const COMUNICATI_BOZZE = [
  {
    id: "il-paese-riprese",
    data: "Giugno 2026",
    tag: "Nuova produzione",
    titolo: "Al via le riprese de Il Paese, il nuovo film di Antonio De Palo",
    estratto: "Sul Gargano, tra Capoiale e i Monti Dauni: Red Private è produttore associato.",
    testo:
      "CAPOIALE (FG) / ROMA — Red Private annuncia l'inizio ufficiale delle riprese de Il Paese, l'atteso lungometraggio diretto da Antonio De Palo e da lui scritto insieme a Piero Rossi. Le riprese si svolgono nei suggestivi scenari del Gargano, tra la foce del canale di Capoiale e i Monti Dauni. Il film affronta le dinamiche del giudizio collettivo e dell'isolamento in una piccola comunità chiusa, attorno alla tragica scomparsa di un giovane del posto. Il Paese è prodotto da Lupin Film e Beagle, con Red Private nel ruolo di produttore associato. L'uscita nelle sale è prevista nel corso del 2027.",
    en: {
      data: "June 2026",
      tag: "New production",
      titolo: "Shooting begins on Il Paese, the new film by Antonio De Palo",
      estratto: "In the Gargano, between Capoiale and the Monti Dauni: Red Private is associate producer.",
      testo:
        "CAPOIALE (FG) / ROME — Red Private announces the official start of shooting on Il Paese, the anticipated feature film directed by Antonio De Palo and co-written with Piero Rossi. Filming takes place in the striking scenery of the Gargano, between the mouth of the Capoiale canal and the Monti Dauni. The film explores the dynamics of collective judgment and isolation within a small closed community, around the tragic disappearance of a local young man. Il Paese is produced by Lupin Film and Beagle, with Red Private as associate producer. Theatrical release is expected in 2027.",
    },
  },
];

export const COMUNICATI = [
  {
    id: "belinelli-sala",
    data: "Marzo 2026",
    tag: "Uscita in sala",
    titolo: "The Basketball Dream: Marco Belinelli — Uscita premium solo il 16/17/18 marzo 2026",
    estratto:
      "Il docufilm sul primo italiano con un anello NBA, diretto da Francesco Lettieri e Giorgio Testi, arriva in sala con un'uscita premium di tre giorni.",
    testo:
      "Scritto da Francesco Zippel e diretto da Francesco Lettieri e Giorgio Testi, The Basketball Dream: Marco Belinelli racconta la parabola del cestista di San Giovanni in Persiceto fino al titolo NBA con i San Antonio Spurs. Prodotto da Red Private in due versioni — 75' per il cinema e due episodi da 50' per Rai Documentari — arriva in sala con un'uscita premium solo il 16, 17 e 18 marzo 2026.",
    en: {
      data: "March 2026",
      tag: "Theatrical release",
      titolo: "The Basketball Dream: Marco Belinelli — Premium release March 16/17/18, 2026 only",
      estratto:
        "The docufilm about the first Italian to win an NBA ring, directed by Francesco Lettieri and Giorgio Testi, hits theaters with a three-day premium release.",
      testo:
        "Written by Francesco Zippel and directed by Francesco Lettieri and Giorgio Testi, The Basketball Dream: Marco Belinelli tells the story of the player from San Giovanni in Persiceto all the way to the NBA title with the San Antonio Spurs. Produced by Red Private in two versions — a 75' theatrical cut and two 50' episodes for Rai Documentari — it arrives in theaters with a premium release on March 16, 17 and 18, 2026 only.",
    },
  },
  {
    id: "avemaria-tff",
    data: "Novembre 2025",
    tag: "Festival",
    titolo: "AVEMMARIA in Official Selection al 43° Torino Film Festival",
    estratto: "L'esordio alla regia di Fortunato Cerlino selezionato al Torino Film Festival.",
    testo:
      "AVEMMARIA, esordio alla regia di Fortunato Cerlino con Mario Di Leva, Salvatore Esposito e Marianna Fontana, è stato selezionato in Official Selection al 43° Torino Film Festival. Il film è realizzato in co-produzione con partner nazionali, con il contributo di Rai Cinema, ed è distribuito da Europictures.",
    en: {
      data: "November 2025",
      tag: "Festival",
      titolo: "AVEMMARIA in Official Selection at the 43rd Torino Film Festival",
      estratto: "Fortunato Cerlino's directorial debut selected at the Torino Film Festival.",
      testo:
        "AVEMMARIA, Fortunato Cerlino's directorial debut starring Mario Di Leva, Salvatore Esposito and Marianna Fontana, has been selected for the Official Selection of the 43rd Torino Film Festival. The film is co-produced with leading national partners, with the support of Rai Cinema, and is distributed by Europictures.",
    },
  },
  {
    id: "liberato-cinema",
    data: "Maggio 2024",
    tag: "Uscita in sala",
    titolo: "Il Segreto di Liberato: dal 9 maggio al cinema",
    estratto: "Il primo film dedicato a Liberato arriva nelle sale italiane.",
    testo:
      "RED PRIVATE annuncia l'uscita nelle sale de Il Segreto di Liberato, diretto da Francesco Lettieri: la prima opera cinematografica dedicata alla figura enigmatica dell'artista napoletano. Prodotto da Red Private, il film porta sul grande schermo l'universo musicale e visivo di Liberato.",
    en: {
      data: "May 2024",
      tag: "Theatrical release",
      titolo: "Il Segreto di Liberato: in theaters from May 9",
      estratto: "The first film dedicated to Liberato arrives in Italian cinemas.",
      testo:
        "RED PRIVATE announces the theatrical release of Il Segreto di Liberato, directed by Francesco Lettieri: the first cinematic work dedicated to the enigmatic figure of the Neapolitan artist. Produced by Red Private, the film brings Liberato's musical and visual universe to the big screen.",
    },
  },
];

export const STAMPA = {
  contatto: "info@redpvt.com",
  instagram: "https://www.instagram.com/redpvt/",
};
